import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectActiveWinery } from "../context/selectors";
import { ROLES } from "../constants/base";
import { getDashboardSummary } from "../services/dashboard";
import useAuth from "./useAuth";
import useAxiosPrivate from "./useAxiosPrivate";

// Home summary for the active winery. status: "idle" (nothing to load: no winery selected,
// or ADMIN, who has no winery data) | "loading" | "success" | "error".
const useDashboardSummary = () => {
  const { auth } = useAuth();
  const activeWinery = useSelector(selectActiveWinery);
  const axiosPrivate = useAxiosPrivate();

  const wineryId = activeWinery?.id;
  const enabled = Boolean(wineryId) && Number(auth?.role) !== ROLES.ADMIN;

  const [state, setState] = useState({ status: "loading", summary: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;

    let isMounted = true;
    setState({ status: "loading", summary: null });

    (async () => {
      try {
        const summary = await getDashboardSummary(axiosPrivate);
        if (isMounted) setState({ status: "success", summary });
      } catch (e) {
        if (isMounted) setState({ status: "error", summary: null });
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [enabled, wineryId, reloadToken]);

  const reload = useCallback(() => setReloadToken((token) => token + 1), []);

  if (!enabled) return { status: "idle", summary: null, reload };
  return { ...state, reload };
};

export default useDashboardSummary;
